export default __webpack_public_path__ + "static/media/cedar.texture.ad247126.webp";